<template>
	<div>
		<template v-if="type == 'mobile'">
			<div class="py-4 border-semi-grey radius-12">
				<div class="px-3 mb-3 text-center">
					<p class="heading-6 mb-0">{{data.tagline}}</p>
	    		<p class="body-2-2-1">{{data.sub_tagline}}</p>
				</div>
				<div class="w-100 mb-3" v-if="data.slider.length == 1" style="height: 189px !important;">
          <img :src="data.slider[0].image_url" class="img-fit" height="189">
        </div>
    		<div v-if="data.slider.length > 1" class="mb-3">
	    		<flickity ref="flickity" :options="$fullSliderOption">
			      <div class="carousel-cell w-100" :id="slide.id" v-for="slide in  data.slider">
			        <div class="w-100" style="height: 189px !important;">
			          <img :src="slide.image_url" class="img-fit" height="189">
			        </div>
			      </div>
			    </flickity>
			  </div>
			  <div class="pl-3 w-100 mb-3">
			  	<p class="body-1-2 mb-3 pr-3">{{$t('hotel.concierge.fitur.spa.our-recommended-spa')}}</p>
			  	<flickity ref="flickity" class="mb-3" :options="$freeScrollSliderOption">
			      <div class="carousel-cell w-75 mr-3" v-for="product in data.product">
			        <div class="w-100 border-semi-grey radius-12" style="height:288px !important;">
			        	<div class="w-100" style="height:180px;">
									<img v-if="product.image_list.length == 0" :src="product.cover_image_url" class="img-fit radius-12-t">
	    						<img v-else :src="product.image_list[0].image_url" class="img-fit radius-12-t">
			        	</div>
			        	<div class="w-100 p-3">
	        				<p class="mb-0 body-1-2">{{product.name}}</p>
	        				<div class="w-100">
	        					<span class="body-1-2 d-inline-block aling-middle text-orange mr-1">{{$formatCurrency(product.price_sell)}}</span><span class="body-2-2-1 d-inline-block aling-middle" v-if="product.unit != null">/{{product.unit.unit}}</span>
	        				</div>
			        	</div>
			        </div>
			      </div>
			    </flickity>
			  </div>
			  <div class="py-2 px-3 border-semi-grey radius-6 mr-3 ml-auto d-table" @click="goToDetail">
		    	<p class="mb-0 text-green body-2 d-inline-block aling-middle">{{$t('hotel.concierge.fitur.spa.see-more-our-spa')}}</p>
      		<i class="iconsmind-Arrow-Right font-weight-bold d-inline-block aling-middle text-12 text-green"></i>
		    </div>
			</div>
		</template>
		<template v-if="type == 'desktop'">
			<div class="py-3 border-semi-grey radius-12">
				<div class="px-4">
					<div class="row mb-3">
	    			<div class="col-7 align-self-center">
	    				<div class="pr-3 d-inline-block aling-middle">
				    		<p class="sub-heading-1-1 mb-1 text-semi-dark">{{data.tagline}}</p>
				    		<p class="body-2-2-1 mb-0">{{data.sub_tagline}}</p>
				    	</div>
	    			</div>
	    			<div class="col-5 align-self-center">
	    				<div class="py-2 px-4 border-semi-grey radius-6 ml-auto d-table cursor-pointer" @click="goToDetail">
					    	<p class="mb-0 text-green body-2 d-inline-block aling-middle">{{$t('hotel.concierge.fitur.spa.see-more')}}</p>
		        		<!-- <i class="iconsmind-Arrow-Right font-weight-bold d-inline-block aling-middle text-12 text-green"></i> -->
					    </div>
	    			</div>
	    		</div>
				</div>
				<div class="w-100 mb-3 px-4" v-if="data.slider.length == 1" style="height: 189px !important;">
          <img :src="data.slider[0].image_url" class="img-fit radius-6" height="189">
        </div>
    		<div v-if="data.slider.length > 1" class="mb-3 px-4">
	    		<flickity ref="flickity" :options="$fullSliderOption">
			      <div class="carousel-cell w-100" :id="slide.id" v-for="slide in  data.slider">
			        <div class="w-100" style="height: 189px !important;">
			          <img :src="slide.image_url" class="img-fit" height="189">
			        </div>
			      </div>
			    </flickity>
			  </div>
			  <div class="pl-4 w-100 mb-3">
			  	<p class="body-1-2 mb-3 pr-3">{{$t('hotel.concierge.fitur.spa.our-recommended-spa')}}</p>
			  	<flickity ref="flickity" class="mb-3" :options="$freeScrollSliderOption">
			      <div class="carousel-cell w-45 mr-3" v-for="product in data.product">
			        <div class="w-100 border-semi-grey radius-12" style="height:288px !important;">
			        	<div class="w-100" style="height:180px;">
	    						<img v-if="product.image_list.length == 0" :src="product.cover_image_url" class="img-fit radius-12-t">
	    						<img v-else :src="product.image_list[0].image_url" class="img-fit radius-12-t">
			        	</div>
			        	<div class="w-100 p-3">
	        				<p class="mb-0 body-1-2">{{product.name}}</p>
	        				<div class="w-100">
	        					<span class="body-1-2 d-inline-block aling-middle text-orange mr-1">{{$formatCurrency(product.price_sell)}}</span><span class="body-2-2-1 d-inline-block aling-middle" v-if="product.unit != null">/{{product.unit.unit}}</span>
	        				</div>
			        	</div>
			        </div>
			      </div>
			    </flickity>
			  </div>
			</div>
		</template>
	</div>
</template>
<script>
  import Flickity from 'vue-flickity';
  import {mapGetters} from 'vuex'

	export default{
		props:['type','data'],
		components:{
			Flickity
		},
		computed:{
			...mapGetters(['getMerchant'])
		},
		methods:{
			goToDetail(){
				this.$postLog('HOME','MODULE PREVIEW',`Clicked detail ${this.data.code}`)
				this.$router.push(`/${this.getMerchant.code}/concierge/spa`)
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/hotel/general/SpaPreview.vue